import { createContext, useState, useContext, useEffect } from 'react'
import http from '@/lib/axios'

const HeaderContext = createContext()

export const useHeader = () => useContext(HeaderContext)

export const HeaderProvider = ({ children }) => {
  const [userInfo, setUserInfo] = useState({})

  useEffect(() => {
    http.get('/app/aiUser/getInfo').then((res) => {
      setUserInfo(res)
    })
  }, [])

  return (
    <HeaderContext.Provider value={{ userInfo }}>
      {children}
    </HeaderContext.Provider>
  )
}
